import React, { useState } from "react";
import { Button } from "@mui/material";
import "./OnBoardingScreen.css";
import useTranslationSetup from "../../utils/useTranslationSetup";
import CloudTop from "../../assets/onboarding-illustration.svg";
import AssessmentFlow from "../../assets/assessment-flow.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SCREENS } from "../../utils/CommonUtils/constants";

function OnBoardingScreen({ setActiveScreen }) {
  const { t } = useTranslationSetup();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { question: t("faq_question_1"), answer: t("faq_answer_1") },
    { question: t("faq_question_2"), answer: t("faq_answer_2") },
    { question: t("faq_question_3"), answer: t("faq_answer_3") },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div>
        <img src={CloudTop} alt="Clouds" className="cloud-top-img" />
      </div>

      <div className="onboarding-screen-container">
        <div className="onboarding-screen-heading-text">
          {t("onboarding_screen_1")}
        </div>
        <div className="onboarding-screen-content-wrapper">
          <div className="onboarding-screen-content-1">
            {t("onboarding_screen_2")}
          </div>
        </div>
        <div className="onboarding-screen-question">
          {t("onboarding_screen_3")}
        </div>
        <div className="assessment-flow-img-container">
          <img
            src={AssessmentFlow}
            alt="assessment_flow"
            className="assessment-flow-img"
          />
        </div>
        <div className="onboarding-screen-content-2">
          {t("onboarding_screen_4")}
        </div>
        <div className="onboarding-faq">{t("faq_question")}</div>
        <div className="faqs-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <ExpandMoreIcon
                  className={`icon ${openIndex === index ? "rotate" : ""}`}
                />
              </div>
              {openIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="onboarding-sticky-button">
        <Button
          variant="contained"
          style={{
            height: "46px",
            width: "100%",
            textTransform: "none",
            borderRadius: "10px",
            color: "#FFFFFF",
            fontSize: "16px",
            fontFamily: "poppins-regular",
            background: "#A2C357",
            boxShadow: "#3B43450A",
          }}
          disableElevation
          onClick={() => setActiveScreen(SCREENS.RENDER_NEED_PERMISSION_SCREEN)}
        >
          {t("go_next")}
        </Button>
      </div>
    </div>
  );
}

export default OnBoardingScreen;
